/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-01-19 12:00:40
 *
 *******************************************************/
// @flow

// import _ from 'lodash';
import React, { Component } from 'react';
import { FormLayout, Icon, TextStyle, Link, Tooltip } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { ExternalMinor, QuestionMarkMinor } from '@shopify/polaris-icons';

import { Field } from 'redux-form';
import { RenderRadioButton2 } from 'src/components/views/common/forms/render-radio-button-2';
import { URL } from 'src/constants/links';

import {
  // PRODUCT_IMAGE_AREA_ARRANGEMENT_VALUE,
  PRODUCT_IMAGE_AREA_ARRANGEMENT_OPTIONS
} from 'src/constants/theme-settings';
import { capitalizeFirstLetter } from 'src/helpers';

type Props = {
  formValues: any,
  updateField: (field: string, value: any) => void
};

type ComposedProps = Props & WithI18nProps;

class ProductImageAreaForm extends Component<ComposedProps> {
  // componentWillReceiveProps(nexProps) {
  //   const { prefix } = this.props;
  //   const { prefix: nextPrefix, updateField, formValues } = nexProps;
  //   if (prefix !== nextPrefix && !_.get(formValues, nextPrefix)) {
  //     updateField(`${nextPrefix}.arrangement`, PRODUCT_IMAGE_AREA_ARRANGEMENT_VALUE.HORIZONTAL);
  //   }
  // }

  render() {
    const { i18n, prefix } = this.props;
    const formattedProductImageAreaArrangement = PRODUCT_IMAGE_AREA_ARRANGEMENT_OPTIONS.map(
      item => ({
        ...item,
        label: i18n.translate(item.label)
      })
    );

    const isAreaTop = prefix?.toLowerCase().includes('top');
    const isAreaMiddle = prefix?.toLowerCase().includes('middle');

    const area = isAreaTop
      ? i18n.translate('AdminHTML.ThemeSetting.Common.top')
      : isAreaMiddle
      ? i18n.translate('AdminHTML.ThemeSetting.Common.middle')
      : i18n.translate('AdminHTML.ThemeSetting.Common.bottom');

    return (
      <FormLayout>
        <div>
          <div>
            <span className="form-link form-link--normal">
              <TextStyle variation="subdued">
                {i18n.translate('AdminHTML.ThemeSetting.Form.productImageArea_UserGuide1', {
                  area: area
                })}
              </TextStyle>{' '}
              <Tooltip
                content={
                  <div className="form-link__product-image-area-tooltip">
                    <div className="form-link__product-image-area-tooltip__top">
                      <div
                        className={`form-link__product-image-area-tooltip__item ${
                          isAreaTop ? 'active' : ''
                        }`}></div>
                      <div
                        className={`form-link__product-image-area-tooltip__item ${
                          isAreaMiddle ? 'active' : ''
                        }`}></div>
                      <div
                        className={`form-link__product-image-area-tooltip__item ${
                          !isAreaTop && !isAreaMiddle ? 'active' : ''
                        }`}></div>
                    </div>
                    <div className="form-link__product-image-area-tooltip__body">
                      <p className="name">Small Naomi</p>
                      <p className="vendor">PULL& PEAR</p>
                      <p className="price">$485.00 CAD</p>
                    </div>
                  </div>
                }
                preferredPosition="above">
                <Icon source={QuestionMarkMinor} color="base" />
              </Tooltip>
            </span>
          </div>

          <div style={{ marginTop: '6px' }}>
            <span className="form-link">
              <TextStyle variation="subdued">
                <span>
                  {i18n.translate('AdminHTML.ThemeSetting.Form.productImageArea_UserGuide2', {
                    area: capitalizeFirstLetter(area)
                  })}
                </span>
              </TextStyle>{' '}
              <Link url={URL['ProductImageAreaThemeSetting']} external>
                {i18n.translate('AdminHTML.ThemeSetting.Common.clickHere')}
                <Icon source={ExternalMinor} color="base" />
              </Link>
              <span style={{ color: '#2C6ECB' }}>.</span>
            </span>
          </div>
        </div>

        <div className="form-section">
          <p className="subtitle" style={{ marginBottom: '4px' }}>
            {i18n.translate('AdminHTML.ThemeSetting.Form.productImageArea_Arrangement_Item')}
          </p>
          <div className="form-section__item">
            <div className="radio-button-wrapper radio-button-wrapper--no-gap radio-button-wrapper--bordered">
              {formattedProductImageAreaArrangement.map((item, index) => (
                <Field
                  key={index}
                  name={`${prefix}.arrangement`}
                  id={item.value}
                  component={RenderRadioButton2}
                  label={item.label}
                />
              ))}
            </div>
          </div>
        </div>
      </FormLayout>
    );
  }
}

export default withI18n()(ProductImageAreaForm);
